import React, { useEffect, useRef } from 'react'

const ClickOutside = ({
  children,
  style = {},
  onClose,
  onClick,
  className = '',
  disableClickHandler = false,
}) => {
  const outsideClickRef = useRef(null)

  const handleClickEvent = (event) => {
    if (!outsideClickRef.current?.contains(event.target)) {
      onClose?.(event)
    }
  }

  useEffect(() => {
    if (!disableClickHandler) {
      setTimeout(() => {
        document.addEventListener('click', handleClickEvent)
      }, 0)
    }

    return () => {
      if (!disableClickHandler) {
        setTimeout(() => {
          document.removeEventListener('click', handleClickEvent)
        }, 0)
      }
    }
  }, [])

  return (
    <div
      role="presentation"
      className={`click-outside-div ${className}`}
      onClick={onClick}
      style={style}
      ref={outsideClickRef}
    >
      {children}
    </div>
  )
}

export default ClickOutside
